import { createStyles } from '@mantine/core';
import TYPOGRAPHY_FLAT from '@styles/fonts/fontsizes/typography-flat';

export const useStyles = createStyles(() => {
  return {
    root: {
      cursor: 'pointer',
      display: 'inline-flex',
    },
    input: {
      borderColor: 'var(--beam-color-neutral-n400)',
      cursor: 'pointer',
      '&:checked': {
        borderColor: 'var(--beam-color-blue-b401)',
      },
    },
    label: {
      ...TYPOGRAPHY_FLAT.p200,
    },
    body: {
      alignItems: 'center',
    },
  };
});
